<template>
  <div class="horus-audio-modal">
    <horus-modal-frame
      :showModalFlag="audioModalShow">
      <div class="modal-header" style="padding: 0;">
        <div class="header-title">
          <div class="author-column" v-if="author">
            <horus-record-head-info
              :timelineOwner="timelineOwner"
              :author="author"
              :targetAt="targetAt"
              :displayStyle="'responsible-small'"
              v-on:modalOpenEvent="showAuthorInfo" />
          </div>
          <div class="title">
            <img src="/static/images/audio_play_icon.png" />投稿音声
          </div>
          <div class="close-btn">
            <img src="/static/images/x_icon.png" @click="closeModal" />
          </div>
        </div>
        <div class="narrow-header-author">
          <horus-record-head-info
            :timelineOwner="timelineOwner"
            :author="author"
            :targetAt="targetAt"
            :displayStyle="'responsible-small'"
            v-on:modalOpenEvent="showAuthorInfo" />
        </div>
      </div>
      <div class="modal-body">
        <div class="audio-player" v-html="audioIframe"></div>
      </div>
    </horus-modal-frame>
  </div>
</template>

<script>
import { MillviAPI } from '@/api'

import HorusModalFrame from '@/components/common/HorusModalFrame.vue'
import HorusRecordHeadInfo from '@/components/timelineRecord/HorusRecordHeadInfo.vue'

export default {
  name: 'HorusAudioModal',

  components: {
    HorusModalFrame,
    HorusRecordHeadInfo
  },

  props: {
    audioModalShow: Boolean,
    audioContent: Object
  },

  data () {
    return {
      timelineOwner: null,
      author: null,
      targetAt: null,
      audioIframe: ''
    }
  },

  watch: {
    audioContent: { handler: 'initObjects', immediate: true }
  },

  computed: {
  },

  methods: {
    initObjects () {
      if (this.audioContent) {
        this.timelineOwner = this.audioContent.timelineRecord.timelineOwner
        this.author = this.audioContent.timelineRecord.author
        this.targetAt = this.audioContent.timelineRecord.targetAt
        this.getAudioIframe()
      } else {
        this.timelineOwner = null
        this.author = null
        this.targetAt = null
        this.audioIframe = ''
      }
    },

    getAudioIframe () {
      MillviAPI.fetchAudioTagSet({ targetUserID: this.timelineOwner.id, audioID: this.audioContent.id }).then(res => {
        this.audioIframe = res.tag
      })
    },

    showAuthorInfo (targetElm, callback) {
      this.$emit('modalOpenEvent', targetElm, callback)
    },

    closeModal () {
      this.$emit('closeAudioModalEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mediaQuery.scss';

.horus-audio-modal {
  .horus-modal-frame {
    .modal {
      width: calc(100% - 100px);
    }
  }
  .modal-header {
    padding: 0;
    .header-title {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 5px 10px;
      height: 50px;
      &.tag-include {
        height: 70px;
      }
      @include mediaQuery('phone') {
        height: 30px;
        padding-bottom: 0;
        .author-column {
          display: none;
        }
      }
      .title {
        text-align: center;
        img {
          width: 15px;
        }
      }
      .close-btn {
        text-align: right;
        height: 30px;
        img {
          cursor: pointer;
        }
        .jump-to-origin {
          margin-right: 20px;
          vertical-align: top;
        }
      }
      .tag-display {
        width: 100%;
        height: 20px;
        text-align: right;
      }
    }
    .narrow-header-author {
      display: none;
      @include mediaQuery('phone') {
        display: block;
        padding: 0 10px 5px;
      }
    }
  }
  .modal-body {
    .audio-player {
      margin: 10px;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
